import React from 'react';
import { Link } from 'react-router-dom';
import PaintTitle from './PaintTitle';

export default function FeaturedProject({ project, id = 'featured', focusQuery = '' }) {
    if (!project) return null;
    return <section className="work-feature" id={id}>
        <div className="work-heading"><span className="section-label">01 / Featured build</span><PaintTitle>{project.title}</PaintTitle></div>
        <div className="work-lead">
            <a className="work-image" href={project.externalUrl} target="_blank" rel="noreferrer" aria-label="View the live Kianti Swim store">
                <img src={project.images[0]} alt="Kianti Swim storefront featuring the Faux Pas collection" width="1248" height="560" />
            </a>
            <div className="work-intro">
                <h3>The storefront and the systems behind it.</h3>
                <p>I designed and built Kianti Swim's online store, including the customer-facing website, inventory tools, automated order emails, and newsletter signup flow.</p>
                <p className="work-meta">January 2026 - Present</p>
                <div className="work-links"><a href={project.externalUrl} target="_blank" rel="noreferrer">View live store</a><Link to={`/project/${project.id}${focusQuery}`}>How I built it</Link></div>
            </div>
        </div>
        <div className="work-highlights">
            <article><span className="section-label">01 / Inventory</span><h3>Stock updates during live sales</h3><p>A Retool workflow for managing stock alongside customer purchases.</p></article>
            <article><span className="section-label">02 / Communication</span><h3>Shipping events and emails</h3><p>Shippo tracking connected to shipping and delivery messages through Resend.</p></article>
            <article><span className="section-label">03 / Newsletter</span><h3>Signups with confirmation</h3><p>Pending subscribers in DynamoDB, confirmation through Resend, and distribution through Mailchimp.</p></article>
        </div>
    </section>;
}
